export default __webpack_public_path__ + "static/media/who it is for.12029061.png";